import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Check, Package, Truck, Download, Home, ShoppingBag } from 'lucide-react';
import { BiCategoryAlt } from "react-icons/bi";
import { IoSearchOutline } from "react-icons/io5";
import { MdOutlineAccountCircle } from "react-icons/md";
import { FaShoppingCart } from "react-icons/fa";
import { IoHome } from "react-icons/io5";
const OrderConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState(null);

  useEffect(() => {
    // Fetch order details using orderId from location state
    const fetchOrderDetails = async () => {
      try {
        const response = await fetch(`/api/orders/${location.state.orderId}`, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        });
        const data = await response.json();
        setOrderDetails(data);
      } catch (error) {
        console.error('Error fetching order details:', error);
      }
    };

    if (location.state?.orderId) {
      fetchOrderDetails();
    }
  }, [location.state]);

  const getOrderDate = () => {
    if (!orderDetails) return '';
    return new Date(orderDetails.orderDate).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  return (
    <>
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {/* Success Message */}
        <div className="text-center mb-12">
          <div className="mb-4">
            <div className="h-16 w-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
              <Check className="h-8 w-8 text-green-600" />
            </div>
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Order Confirmed!</h1>
          <p className="text-gray-600">Thank you for your order. We've received your payment.</p>
        </div>

        {/* Order Details Card */}
       
        {/* Customer Support */}
        <div className="text-center text-sm text-gray-600">
          <p>Need help? Contact our customer support</p>
          <p className="font-medium">support@example.com | +1 234 567 890</p>
        </div>
      </div>
    </div>
    <div class="tf-toolbar-bottom type-1150">
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/">
                <div class="toolbar-icon">
                <IoHome />
                </div>
                <div class="toolbar-label">Home</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/products" >
                <div class="toolbar-icon">
                <BiCategoryAlt />
                </div>
                <div class="toolbar-label">Shop</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/SearchBar" >
                <div class="toolbar-icon">
                <IoSearchOutline />
                </div>
                <div class="toolbar-label">Search</div>
            </a>
        </div>
        <div class="toolbar-item">
            <a style={{color:"black"}} href="/cart">
                <div class="toolbar-icon">
                <FaShoppingCart />
                </div>
                <div class="toolbar-label">Cart</div>
            </a>
        </div>
    </div>
    </>
  );
};

export default OrderConfirmation;